<template>
  <v-container fluid>
    <a-page-header title="Demandes" icon="flaticon-question"/>       

    <v-divider/>

     <v-row>
        <v-col sm="12">
          <v-tabs v-model="tab" >
              <v-tab href="#tab-1" @click="onClickTab('stream')">Flux</v-tab>
              <v-tab href="#tab-2" @click="onClickTab('activated')">Actives</v-tab>
              <v-tab href="#tab-3" @click="onClickTab('completed')">Terminées</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab" >
            <v-tab-item value="tab-1">
              <v-card flat>
                <v-card-text>
                    <div>
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Rechercher"
                        single-line
                        hide-details
                        clearable
                      ></v-text-field>
                  </div>

                  <v-list rounded>
                    <a-request-item v-for="(item, index) in filteredRequests.stream" :item="item" :key="item.id" :last="index === filteredRequests.stream.length - 1" @select="onClickRequestItem"/>                    
                  </v-list>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item value="tab-2">
              <v-card flat>
                <v-card-text>
                  <div>
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Rechercher"
                        single-line
                        hide-details
                        clearable
                      ></v-text-field>
                  </div>

                  <v-row align="center">
                    <v-col sm="2">
                      <v-switch
                        v-model="showAppointment"
                        flat
                        dense
                        label="Rendez-vous"
                      ></v-switch>
                    </v-col>

                    <v-col sm="2">
                      <v-switch
                        v-model="showAssistance"
                        flat
                        dense
                        label="Assistances"
                      ></v-switch>
                    </v-col>

                    <v-spacer></v-spacer>

                    <v-col cols="auto" v-if="showActionButton && multiSelectMode">
                      <v-btn
                        color="red"
                        dark
                        small
                        :disabled="selectedIds.length === 0"
                        @click="confirmDeleteDialog = true"
                      >
                        <v-icon left small>mdi-delete</v-icon>
                        Supprimer la sélection ({{ selectedIds.length }})
                      </v-btn>
                    </v-col>

                    <v-col cols="auto" v-if="showActionButton">
                      <v-switch
                        v-model="multiSelectMode"
                        flat
                        dense
                        label="Sélection multiple"
                      ></v-switch>
                    </v-col>
                  </v-row>


                  <div class="text-center mt-10" v-if="isLoading">
                    <v-progress-circular
                      :size="50"
                      :width="3"
                      indeterminate
                    ></v-progress-circular>
                  </div>
                  <template v-else>
                    <div v-if="showActionButton && multiSelectMode" class="d-flex align-center pl-2">
                      <v-checkbox
                        :input-value="isAllSelected(filteredRequests.activated)"
                        :indeterminate="isIndeterminate(filteredRequests.activated)"
                        label="Tout sélectionner"
                        hide-details
                        dense
                        class="mt-0 pt-0"
                        @change="toggleSelectAll(filteredRequests.activated)"
                      ></v-checkbox>
                    </div>
                    <v-list rounded>
                      <a-request-item v-for="(item, index) in filteredRequests.activated"
                        :item="item"
                        :key="item.id"
                        :btn-delete="showActionButton && !multiSelectMode"
                        :selectable="showActionButton && multiSelectMode"
                        :selected="selectedIds.includes(item.id)"
                        :last="index === filteredRequests.activated.length - 1"
                        @delete="deleteItem"
                        @toggle-select="toggleSelectItem"
                        @select="onClickRequestItem"/>
                    </v-list>
                  </template>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab-item value="tab-3">
              <v-card flat>
                <v-card-text>
                  <div>
                      <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Rechercher"
                        single-line
                        hide-details
                        clearable
                      ></v-text-field>
                  </div>

                  <v-row align="center">
                    <v-col sm="2">
                      <v-switch
                        v-model="showAppointment"
                        flat
                        dense
                        label="Rendez-vous"
                      ></v-switch>
                    </v-col>

                    <v-col sm="2">
                      <v-switch
                        v-model="showAssistance"
                        flat
                        dense
                        label="Assistances"
                      ></v-switch>
                    </v-col>

                    <v-spacer></v-spacer>

                    <v-col cols="auto" v-if="showActionButton && multiSelectMode">
                      <v-btn
                        color="red"
                        dark
                        small
                        :disabled="selectedIds.length === 0"
                        @click="confirmDeleteDialog = true"
                      >
                        <v-icon left small>mdi-delete</v-icon>
                        Supprimer la sélection ({{ selectedIds.length }})
                      </v-btn>
                    </v-col>

                    <v-col cols="auto" v-if="showActionButton">
                      <v-switch
                        v-model="multiSelectMode"
                        flat
                        dense
                        label="Sélection multiple"
                      ></v-switch>
                    </v-col>
                  </v-row>

                  <div class="text-center mt-10" v-if="isLoading">
                    <v-progress-circular
                      :size="50"
                      :width="3"
                      indeterminate
                    ></v-progress-circular>
                  </div>
                  <template v-else>
                    <div v-if="showActionButton && multiSelectMode" class="d-flex align-center pl-2">
                      <v-checkbox
                        :input-value="isAllSelected(filteredRequests.completed)"
                        :indeterminate="isIndeterminate(filteredRequests.completed)"
                        label="Tout sélectionner"
                        hide-details
                        dense
                        class="mt-0 pt-0"
                        @change="toggleSelectAll(filteredRequests.completed)"
                      ></v-checkbox>
                    </div>
                    <v-list rounded>
                      <a-request-item v-for="(item, index) in filteredRequests.completed"
                        :item="item"
                        :key="item.id"
                        :btn-delete="showActionButton && !multiSelectMode"
                        :selectable="showActionButton && multiSelectMode"
                        :selected="selectedIds.includes(item.id)"
                        :last="index === filteredRequests.completed.length - 1"
                        @delete="deleteItem"
                        @toggle-select="toggleSelectItem"
                        @select="onClickRequestItem"/>
                    </v-list>
                  </template>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
     </v-row>

     <v-dialog v-model="confirmDeleteDialog" max-width="420">
        <v-card>
          <v-card-title>Confirmer la suppression</v-card-title>
          <v-card-text>
            Voulez-vous vraiment supprimer {{ selectedIds.length }} demande(s) sélectionnée(s) ? Cette action est irréversible.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="confirmDeleteDialog = false">Annuler</v-btn>
            <v-btn color="red" dark :loading="isDeletingSelection" @click="deleteSelection">Supprimer</v-btn>
          </v-card-actions>
        </v-card>
     </v-dialog>

  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import requestService from '@/services/requestService'
import APageHeader from "@/components/APageHeader"
import ARequestItem from "@/components/ARequestItem"

export default {
  name: 'Requests',
  components: { APageHeader, ARequestItem },
  data: () => ({
    intervalId: undefined,
    interval: 10000,
    isLoading: false,
    showAppointment: true,
    showAssistance: true,
    multiSelectMode: false,
    selectedIds: [],
    isDeletingSelection: false,
    confirmDeleteDialog: false,
    requests: {
      stream: [],
      activated: [],
      completed: [],
      failed: []
    },
    filteredRequests: {
      stream: [],
      activated: [],
      completed: [],
      failed: []
    },
    status: 'stream',
    search: ''
  }),
  methods: {
    // Méthodes d'évènements
    // ---------------------
    onClickRequestItem: function(id) {
      this.$router.push({ 
        name: 'Request', 
        params: { 
          id: id
        }
      })    
    },

    onClickTab: function(status) {      
      if (status !== undefined) this.status = status     
      this.search = ''
      this.showAssistance = true
      this.showAppointment = true
      this.get()
    },
    statusFromTab: function(tab) {
      if (tab === 'tab-2') return 'activated'
      if (tab === 'tab-3') return 'completed'
      return 'stream'
    },

    // Méthodes d'accès aux données
    // ----------------------------
    // Liste des demandes de l'utilisateur
    get: function() {
        this.isLoading = true
        requestService.getAll(this.status)
            .then(data => {
                  this.requests[this.status] = data
                  this.filterRequests()
                this.isLoading = false
            })
            .catch(error => {
              console.log(error)
                this.isLoading = false
                this.$root.$emit("serverError", error);
            });
    },

    // Méthodes fonctionnelles
    // -----------------------
    deleteItem: function(id) {
      this.requests[this.status] = this.requests[this.status].filter(el => el.id !== id)
      this.filteredRequests[this.status] = this.filteredRequests[this.status].filter(el => el.id !== id)
    },
    toggleSelectItem: function(id) {
      if (this.selectedIds.includes(id)) this.selectedIds = this.selectedIds.filter(el => el !== id)
      else this.selectedIds = [...this.selectedIds, id]
    },
    isAllSelected: function(list) {
      return list.length > 0 && list.every(el => this.selectedIds.includes(el.id))
    },
    isIndeterminate: function(list) {
      return list.some(el => this.selectedIds.includes(el.id)) && !this.isAllSelected(list)
    },
    toggleSelectAll: function(list) {
      const ids = list.map(el => el.id)
      if (this.isAllSelected(list)) this.selectedIds = this.selectedIds.filter(id => !ids.includes(id))
      else this.selectedIds = [...new Set([...this.selectedIds, ...ids])]
    },
    deleteSelection: function() {
      if (this.selectedIds.length === 0) return
      this.isDeletingSelection = true
      requestService.remove(this.selectedIds.join(','))
          .then(() => {
            this.selectedIds.forEach(id => this.deleteItem(id))
            this.selectedIds = []
            this.isDeletingSelection = false
            this.confirmDeleteDialog = false
          })
          .catch(error => {
            this.isDeletingSelection = false
            this.confirmDeleteDialog = false
            this.$root.$emit("serverError", error);
          });
    },
    // Filtre les demandes du status en cour en fonction du contenu de la zone de recherche
    filterRequests: function() {         
      if (!this.requests[this.status]) return [];

      this.filteredRequests[this.status] = this.requests[this.status].filter(el =>  {  
            let filterResult = true
            if (this.search && this.search != '') {
              filterResult = `${el.requester.lastname} ${el.requester.firstname} ${el.requester.work.name} ${el.requester.work.agency ? el.requester.work.agency.name : ''} ${el.vehicle ? el.vehicle.registration : ''}}`.toLowerCase().indexOf(this.search.toLowerCase()) !== -1  
            }
            if (filterResult) {              
              if (this.showAppointment && el.type == this.$constants.dossiers.TYPE_APPOINTMENT) filterResult = true
              else if (this.showAssistance && el.type == this.$constants.dossiers.TYPE_ASSISTANCE) filterResult = true              
              else filterResult = false
            }
           
            return filterResult
        })     
    }

  },
  watch: {
    search: function() {      
       this.filterRequests()
    },
    showAppointment: function() { 
      this.filterRequests()
    },
    showAssistance: function() {
      this.filterRequests()
    },
    tab: function(value) {
      const status = this.statusFromTab(value)
      if (status !== this.status) this.onClickTab(status)
    },
    multiSelectMode: function() {
      this.selectedIds = []
      this.confirmDeleteDialog = false
    },
    status: function() {
      this.multiSelectMode = false
      this.selectedIds = []
      this.confirmDeleteDialog = false
    }
  },
  computed: {
    ...mapGetters([
      'userEnvironment',
      'profile',
      'requestsTab'
    ]),
    tab: {
      get() {
        return this.requestsTab
      },
      set(value) {
        this.$store.commit('setRequestsTab', value)
      }
    },
    showActionButton: function() {  return this.profile.is_su || this.profile.role == this.$constants.users.USER_ROLE_MANAGER || this.profile.role == this.$constants.users.USER_ROLE_ADMIN }
  },
  mounted() {
    this.onClickTab(this.statusFromTab(this.tab))
    this.intervalId = setInterval(() => { 
        if (this.status == 'stream') this.get()
      }, 
      this.interval)
  },
  destroyed() {
    clearInterval(this.intervalId)
  }
}
</script>

<style scoped>

</style>
